import React, { useEffect, useState } from "react";
import { fetchReportShelterIntakesExits } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";
import { start } from "repl";

interface ShelterExitDayTypeMetricState {
  data?: any[];
  setSelectedData: (data: any[] | null) => void;
  active: boolean;
  exitType: string;
  startDate?: string;
  useDatePicker?: boolean;
  onHandleClick?: any;
}

export const ShelterExitDayTypeMetric = ({
  data,
  setSelectedData,
  active,
  exitType,
  startDate,
  useDatePicker = false,
  onHandleClick,
}: ShelterExitDayTypeMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [dayRange, setDateRange] = useState<number>(7);
  const [current, setCurrent] = useState<string>();
  const [currentData, setCurrentData] = useState<any[]>();
  const [readOnly, setReadOnly] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        let range = 7;
        if (startDate) {
          range = getDayRangeFromStartDate(startDate);
          setDateRange(range);
        }
        const recent = data.filter((item: any) => isWithinLastXDays(item, range + 1) && item.exit_type === exitType);
        const recentCount = recent.length.toString();
        setCurrent(recentCount);
        setCurrentData(recent);
        setReadOnly(false);
        setIsLoading(false);
      } else {
        await getExitsData();
        setIsLoading(false);
      }
    };

    fetchData();
  }, [data, startDate, useDatePicker]);

  const getExitsData = async () => {
    await fetchReportShelterIntakesExits()
      .then((res: any) => {
        const data = res[0].data;
        const range = startDate ? getDayRangeFromStartDate(startDate) : 7;
        setDateRange(range);
        const recent = data.filter((item: any) => isWithinLastXDays(item, range + 1) && item.exit_type === exitType);
        const recentCount = recent.length.toString();
        setCurrent(recentCount);
        setCurrentData(recent);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  function getDayRangeFromStartDate(start: string): number {
    const today = new Date();
    today?.setHours(0, 0, 0, 0);
    const startDate = new Date(start);
    startDate?.setHours(0, 0, 0, 0);
    const dayRangeTime: number = today.getTime() - startDate.getTime();
    return Math.ceil(dayRangeTime / (1000 * 60 * 60 * 24)) - 1;
  }

  function isWithinLastXDays(item: any, dayRange: number) {
    const today = new Date();
    const exitDate = new Date(item.exit_at);
    today.setHours(0, 0, 0, 0);
    exitDate.setHours(0, 0, 0, 0);

    const diffInTime: number = today.getTime() - exitDate.getTime();
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

    return diffInDays >= 0 && diffInDays <= dayRange; // 7 days + today
  }

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(currentData || null);
    } else {
      setSelectedData(null);
    }

    onHandleClick();
  };

  if (readOnly) {
    return (
      <SingleCardMetric
        title={`Exits Last ${dayRange} Days (${exitType.charAt(0).toUpperCase() + String(exitType).slice(1)})`}
        total={current}
        isLoading={isLoading}
      />
    );
  } else {
    return (
      <SingleCardMetric
        title={`Exits Last ${dayRange} Days (${exitType.charAt(0).toUpperCase() + String(exitType).slice(1)})`}
        total={current}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
